<em [ngClass]="message.icon == icon ? 'font-bold' : ''" class="fal {{icon}} me-1 fa-2x"
    (click)="message.icon = icon"></em>
